var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 60,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              { attrs: { slot: "text-content" }, slot: "text-content" },
              [
                _vm.value
                  ? _c("pnet-extra-vehicle-information", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isExtraVehicleInfoActive,
                          expression: "isExtraVehicleInfoActive",
                        },
                      ],
                      attrs: {
                        quote: _vm.value,
                        vehicle: _vm.vehicle,
                        customer: _vm.customer,
                      },
                      model: {
                        value: _vm.submitQuoteObject.extraVehicleInformation,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.submitQuoteObject,
                            "extraVehicleInformation",
                            $$v
                          )
                        },
                        expression: "submitQuoteObject.extraVehicleInformation",
                      },
                    })
                  : _vm._e(),
                _vm.value
                  ? _c("image-select", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isImageAttachActive,
                          expression: "isImageAttachActive",
                        },
                      ],
                      attrs: {
                        "quote-id": _vm.value.quoteId,
                        "max-selected": _vm.maxImages,
                        subtitle: `Select ${_vm.maxImages} images to submit`,
                      },
                      model: {
                        value: _vm.selectedImageIds,
                        callback: function ($$v) {
                          _vm.selectedImageIds = $$v
                        },
                        expression: "selectedImageIds",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.value.pnet.extraVehicleInfo &&
                        _vm.isImageAttachActive === true,
                      expression:
                        "value.pnet.extraVehicleInfo && isImageAttachActive === true",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Previous" },
                  on: {
                    click: function ($event) {
                      return _vm.previous()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-24px mdi-chevron-left" }),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isExtraVehicleInfoActive === true,
                      expression: "isExtraVehicleInfoActive === true",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Next" },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-24px mdi-chevron-right" }),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isImageAttachActive === true,
                      expression: "isImageAttachActive === true",
                    },
                  ],
                  staticClass: "button is-primary tooltip",
                  attrs: {
                    "data-tooltip": "Submit Quote",
                    disabled: _vm.selectedImageCount > _vm.maxImages,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-send" }),
                  ]),
                  _c("span", [_vm._v("Submit")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: { "data-tooltip": "Cancel" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }